import React, { Component } from 'react';
import { themr } from 'react-css-themr';
import { InputWithButtonPopoverList } from 'common/components/core/input';
import { translate } from 'react-i18next';
import compose from 'recompose/compose';
import classnames from 'classnames';
import { PopoverPlaceEnum } from 'common/components/core/popover/popOverFactory';

import theme from './GeneralFilter.scss';

class GeneralFilter extends Component {
    clear = () => {
        this.props.onChange(null);
    };

    onOptionClick = event => {
        this.props.onChange(event.target.id);
    };

    optionRenderer = ({
        index, // Index of row
        key, // Unique key within array of rendered rows
        style // Style object to be applied to row (to position it);
    }) => {
        const { options, theme } = this.props;
        const option = options[index];
        const { value, label } = option || {};
        const id = String(value);
        return (
            <div
                title={label}
                key={key}
                style={style}
                className={theme.option}
                id={id}
                onClick={this.onOptionClick}
            >
                <span className={theme.label} id={id}>
                    {label}
                </span>
            </div>
        );
    };

    render() {
        const { theme, className, options, value, t } = this.props;
        let valueLabel;
        const disabled = !options.length;

        if (value) {
            //String() is required because filter is stored as string
            //by react-table
            const option = options.find(
                option => String(option.value) === value
            );
            if (option) {
                valueLabel = option.label;
            }
        }

        return options ? (
            <InputWithButtonPopoverList
                disabled={disabled}
                className={classnames(theme.generalFilter, {
                    [className]: !!className
                })}
                theme={theme}
                value={valueLabel || ''}
                onClearInput={this.clear}
                placeholder={t('select')}
                listOptions={options}
                listOptionRenderer={this.optionRenderer}
                listHeight={Math.min(options.length * 25, 150)}
                preferPlace={PopoverPlaceEnum.Below}
            />
        ) : null;
    }
}

export default compose(
    themr('GeneralFilter', theme),
    translate()
)(GeneralFilter);
